import axios from "axios";

export const apiMongo = axios.create({
  baseURL: `${process.env.REACT_APP_MONGO_URL}`,
  withCredentials: true,
});
